<template>
    <div class="actualPrice">
        € {{ this.highestbid }}
    </div>
</template>

<script>

    export default {
        props: {
            bid: {
                type: [Number,String],
                default: ''
            },
            productid: {
                type: [Number,String],
                default: ''
            },
        },

        data () { 
            return {
               highestbid: 0
            }
        },

        mounted: function() {
            App.socket.on('12meins-channel:App\\Events\\UserBid', (data) => {
                if(this.productid == data.productId) {
                    this.highestbid = data.bid;
                }  
            });
        },

        methods: {
        },

        created () {
            this.highestbid = this.bid;
        }
    }
</script>
